import { AptosApiError } from "@aptos-labs/ts-sdk";

import { BaseReader } from "../base-reader";
import { UserSubaccountsRequestArgs, UserSubaccountsSchema } from "./user-subaccounts.types";

export class UserSubaccountsReader extends BaseReader {
  /**
   * Get the subaccounts for a given user
   * @param ownerAddr The address of the owner to get subaccounts for
   * @param limit The number of subaccounts to get (default: 10)
   * @returns The subaccounts for the given user
   */
  async getByAddr({
    ownerAddr,
    // limit = 10,
    fetchOptions,
  }: UserSubaccountsRequestArgs) {
    const queryParams = new URLSearchParams({
      owner: ownerAddr,
      // limit: limit.toString(),
    });

    const response = await this.getRequest({
      schema: UserSubaccountsSchema,
      url: `${this.deps.config.tradingHttpUrl}/api/v1/subaccounts`, // TODO: update to /user_subaccounts?
      queryParams,
      options: fetchOptions,
    });

    return response.data;
  }

  /**
   * Check if an address is a Decibel subaccount by checking for the on-chain Subaccount resource.
   * Only the fullnode's `resource_not_found` means "no"; any other failure rejects.
   */
  async isSubaccount(address: string): Promise<boolean> {
    try {
      // eslint-disable-next-line custom/no-get-account-resource
      await this.deps.aptos.getAccountResource({
        accountAddress: address,
        resourceType: `${this.deps.config.deployment.package}::dex_accounts::Subaccount`,
      });
      return true;
    } catch (e) {
      if (isResourceNotFound(e)) return false;
      throw e;
    }
  }
}

function isResourceNotFound(e: unknown): boolean {
  if (!(e instanceof AptosApiError)) return false;
  const data = e.data as Record<string, unknown> | undefined;
  return data?.error_code === "resource_not_found";
}
